'use client';
import { Text, Box } from '@mentimeter/ragnar-ui';
import React from 'react';
import { Wide } from 'src/ui/layout';
import { H2, P } from 'src/ui/typography';
import { Link } from '../ui/actions';

interface Props {
  name: string;
  address: string;
  mapUrl: string;
  listData?: Array<{
    data: string;
    link: string;
    linkText: string;
  }>;
  children?: React.ReactNode;
}

const OfficeContactInfo = ({
  name,
  address,
  mapUrl,
  listData,
  children,
}: Props) => (
  <Box
    mx="auto"
    width="100%"
    maxWidth="800px"
    alignContent="center"
    px="space8"
    py="space8"
  >
    <Wide alignItems="center">
      <Box
        width={[1, null, 932]}
        flexDirection={['column-reverse', null, 'row']}
      >
        <Box width={[1, null, '450px']} mr={['space0', null, 'space8']}>
          <iframe
            title="Mentimeter office map info"
            src={mapUrl}
            sandbox="allow-scripts allow-same-origin"
            width="100%"
            height="450"
            style={{
              border: '0',
            }}
          />
        </Box>
        <Box
          width={[1, null, '482px']}
          mb={['space4', null, 'space0']}
          flex="1 1 auto"
        >
          <H2 mb="space8">{name}</H2>
          <P mb="space2" fontSize="100" style={{ whiteSpace: 'pre-line' }}>
            {address}
          </P>
          {listData && (
            <Box as="ul" mb={['space2', 'space8']}>
              {listData.map((item) => (
                <Box as="li" key={item.data}>
                  <P mb="space0" fontSize="100">
                    <Text fontSize="125" fontWeight="semiBold">
                      {item.data}{' '}
                    </Text>
                    <Link href={item.link} underline={false}>
                      {item.linkText}
                    </Link>
                  </P>
                </Box>
              ))}
            </Box>
          )}
          {children}
        </Box>
      </Box>
    </Wide>
  </Box>
);

export default OfficeContactInfo;
